import { getAuthHeader, logout } from './authService'
import { API_BASE_URL } from './apiConfig'

/**
 * Authenticated GET request with proper error handling
 */
async function authGet(url) {
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeader()
    }
  })

  if (response.status === 401 || response.status === 403) {
    const data = await response.json().catch(() => ({}))
    const errorMsg = data.error || 'Authentication failed'
    
    if (errorMsg.includes('token') || errorMsg.includes('expired')) {
      logout()
      window.location.href = '/'
      throw new Error('Session expired. Please log in again.')
    }
    throw new Error(errorMsg)
  }
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.error || 'Request failed')
  }
  
  return await response.json()
}

export async function submitFeedback(visitorName, visitorEmail, rating, feedback = '') {
  const response = await fetch(`${API_BASE_URL}/feedback`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      visitorName: visitorName.trim(),
      visitorEmail: visitorEmail.trim(),
      rating: parseInt(rating),
      feedback: feedback.trim(),
    }),
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.error || 'Failed to submit feedback')
  }

  return await response.json()
}

export async function getFeedbackStats() {
  return authGet(`${API_BASE_URL}/feedback/stats/summary`)
}

export async function getFeedbackByRating(rating) {
  return authGet(`${API_BASE_URL}/feedback/rating/${rating}`)
}

export async function getAllFeedback() {
  return authGet(`${API_BASE_URL}/feedback`)
}
